/**
 * Checks if the code is currently executing on the server side (SSR).
 *
 * This function should work for both:
 * - classic-vm SSR (checks __REACT_SSR__)
 * - snapvm-v2 SSR (checks window availability)
 * Read more on classic-vm and snapvm-v2 SSR: https://hello.atlassian.net/wiki/x/3mJR7w
 *
 * @returns {boolean} true if running on server, false if running in browser
 *
 */
export const isServerSide = () => {
  // if SSR is running inside classic-vm, __REACT_SSR__ will be defined
  if (typeof __REACT_SSR__ !== 'undefined') {
    return !!__REACT_SSR__;
  }

  // if SSR is running inside snapvm-v2, window will be undefined
  return typeof window === 'undefined';
};